import store from "../store";
import axios from "axios";

class CodegenSettings {

	async getEngineDefault() {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/codegen_settings/engine_default", {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.settings);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async saveEngineDefault(use_own_credentials, model_preset) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.put(
					`${process.env.VUE_APP_SAAS_BACK}` + "/codegen_settings/engine_default",
					{
						use_own_credentials,
						model_preset,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}
}

export default new CodegenSettings();
